import { defineComponent as y, computed as u, resolveComponent as p, openBlock as a, createElementBlock as b, normalizeClass as f, withKeys as S, createBlock as m, createCommentVNode as c, renderSlot as g, createTextVNode as C, toDisplayString as k } from "vue";
import _ from "../VIcon/VIcon.js";
import V from "../VSpinner/VSpinner.js";
import { useSpacingClass as v } from "../../../composables/useSpacingClass.js";
import { _ as B } from "../../../_plugin-vue_export-helper-dad06003.js";
const z = y({
  name: "VButton",
  emits: ["click"],
  components: {
    VSpinner: V,
    VIcon: _
  },
  props: {
    /** Label of the button */
    type: {
      type: String,
      default: "button"
    },
    order: {
      type: String,
      default: "primary",
      validator(e) {
        return [
          "primary",
          "secondary",
          "tertiary",
          "tertiary-grey",
          "rounded"
        ].indexOf(e) !== -1;
      }
    },
    size: {
      type: String,
      validator(e) {
        return ["s", "m"].indexOf(e) !== -1;
      },
      default: "m"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", "xl", ""].includes(e)
    },
    iconSymbolName: {
      type: String,
      default: ""
    }
  },
  setup(e, t) {
    const { topSpacingClass: l, bottomSpacingClass: s } = v(e), r = (n) => {
      t.emit("click", n);
    }, d = u(() => [
      "hobi-button--" + e.order,
      "hobi-button--size-" + e.size,
      e.bottomSpacing !== "" ? s.value : "",
      e.topSpacing !== "" ? l.value : ""
    ]), o = u(() => e.disabled || e.isLoading);
    return {
      buttonClasses: d,
      onClick: r,
      disableButton: o
    };
  }
});
const N = ["type", "disabled"];
function $(e, t, l, s, r, d) {
  const o = p("VIcon"), n = p("VSpinner");
  return a(), b("button", {
    class: f(["hobi-button", e.buttonClasses]),
    type: e.type,
    onClick: t[0] || (t[0] = (...i) => e.onClick && e.onClick(...i)),
    onKeypress: t[1] || (t[1] = S((...i) => e.onClick && e.onClick(...i), ["enter"])),
    disabled: e.disableButton
  }, [
    e.iconSymbolName ? (a(), m(o, {
      key: 0,
      symbol: e.iconSymbolName,
      size: "16",
      class: "hobi-button__icon"
    }, null, 8, ["symbol"])) : c("", !0),
    g(e.$slots, "default", {}, () => [
      C(k(e.label), 1)
    ], !0),
    e.isLoading ? (a(), m(n, { key: 1 })) : c("", !0)
  ], 42, N);
}
const w = /* @__PURE__ */ B(z, [["render", $], ["__scopeId", "data-v-d1b1de0e"]]);
export {
  w as default
};
